import React from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { TopFilterItemTypes } from './types'

export const TopFilterItem: React.FC<TopFilterItemTypes> = ({ children, fullWide, freeSizes, colspan, className }) => {
  const classNameItem: string = classNames(className, styles.topFilterItem, {
    [styles.topFilterItem_fullWide]: fullWide,
    [styles.topFilterItem_freeSizes]: freeSizes
  })

  const styleObject: React.CSSProperties = {
    gridColumn: colspan ? `span ${colspan}` : undefined
  }

  return (
    <div
      className={ classNameItem }
      style={ styleObject }
    >
      { children }
    </div>
  )
}
